import { Modal, Button } from 'react-bootstrap';
import { useState } from 'react';

// 定義 Props 類型
interface ContactModalProps {
    show: boolean;
    handleClose: () => void;
}

const ResultPresentationModal: React.FC<ContactModalProps> = ({ show, handleClose }) => {
   
    const files = [
        { year: "113年度", name: "評審講評", path: "../imagedoc/epmain/113年度國民中小學線上數位閱讀專題探究競賽總評.pdf" },
        { year: "112年度", name: "評審講評", path: "../imagedoc/epmain/112年度國民中小學線上數位閱讀專題探究競賽總評.pdf" },
        { year: "111年度", name: "評審講評", path: "../imagedoc/epmain/111年度國民中小學線上數位閱讀專題探究競賽總評.pdf" },
        { year: "110年度", name: "評審講評", path: "../imagedoc/epmain/110年度國民中小學線上數位閱讀專題探究競賽總評.pdf" },
      ];
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>歷年成果-參考檔案</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4 text-dblue">
            
            <div className="p-1">
      {/* <h2 className="text-lg font-bold mb-3">參考檔案</h2> */}
      <div className="p-2 pt-1">
      <div  className="table-responsive pt-3">
      <table className="text-sm table table-striped mb-0">
        <thead style={{ backgroundColor: '#dadbe8' ,color:'#5974A2'}} >
        <tr className="font-weight-bolder text-second" >
  <th className="p-2 text-nowrap">年度</th>
  <th className="p-2 text-nowrap">檔案</th>
</tr>
        </thead>
        <tbody>
          {files.map((file, index) => (
            <tr key={index} className="hover:bg-gray-100">
              <td className="">{file.year}</td>
              <td className="">
                <a href={file.path} className="text-blue-500 hover:underline" target="_blank" rel="noopener noreferrer">
                  {file.name}
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      </div>
  </div>
    </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    關閉
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
export default ResultPresentationModal

// 測試用按鈕，示範如何打開 Modal
// const App: React.FC = () => {
//     const [showModal, setShowModal] = useState<boolean>(false);

//     return (
//         <div>
//             <Button variant="primary" onClick={() => setShowModal(true)}>
//                 開啟聯絡資訊
//             </Button>

//             <ContactModal show={showModal} handleClose={() => setShowModal(false)} />
//         </div>
//     );
// };

// export default App;
